import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import { useForm } from "react-hook-form";
import Notification from "../Accounts/Notification/Index";
import LegacyEmailNotification from "../LegacySettings/LegacyEmailNotification";
import LegacyWebNotification from "../LegacySettings/LegacyWebNotification";
import LegacyMobileNotification from '../LegacySettings/LegacyMobileNotification';
import { getAppType, isAddonModuleEnabled } from '../../../Common/Appcommon';
function GetTabsContent () {
    const form = useForm();
    const appType = getAppType();
    const tabsContent = [
        // {
        //     title: 'WhatsApp Notification',
        //     content: <Notification/>,
        //     groupname : 'legacy',
        //     module : 'WA'
        // },
        {
            title: 'Email Notification',
            content: <LegacyEmailNotification />,
            groupname : "legacy",
            module : 'Email',
            apptype : 0
        },
        {
            title: 'Web Notification',
            content: <LegacyWebNotification />,
            groupname : "legacy",
            module : 'Web',
        },
        {
            title: 'Mobile Notification',
            content: <LegacyMobileNotification />,
            groupname : "legacy",
            module : 'Mobile',
        }
    ];
    let modifiedTabs = tabsContent;
    if(appType === '0') {
        modifiedTabs = [];
        tabsContent.map((tab, index) => {
            if(tab.groupname !== "legacy"){
                modifiedTabs.push(tab);
            }
        })
    } else {
        modifiedTabs = [];
        tabsContent.map((tab, index) => {
            if(tab.module === "WA"){
                if(isAddonModuleEnabled("whatsapp")){
                    modifiedTabs.push(tab);
                }
            } else {
                modifiedTabs.push(tab);
            }
        })
    }
    return modifiedTabs;
}

const Notifications = props => {
    const tabsContent = GetTabsContent();
    /*let [modifiedTabs,setModifiedTabs] = useState([{}]);
    
    useEffect(() => {
        getNotificationEnabledList();
        
    },[]);

    const getNotificationEnabledList = async () => {
        let tabList = "";
        tabsContent.map((forms, index) => {
            tabList += forms['formname']+",";
        });
        let response = await getEnabledNotifications(tabList);
        if(response.issuccess){
            let modifiedTab = [];
            let data = response.data;
            data.map((forms, indexs) => {
                tabsContent.map((tab, index) => {
                    if(tab.formname === data[indexs] ){
                        modifiedTab.push(tab);
                    }
                })
            })
            setModifiedTabs(modifiedTab);
        }
    }*/
    function getTabs() {
        let tabsContent = GetTabsContent();
        return tabsContent.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }

    /*const getEnabledNotifications = async (tabList =[]) =>{
        let currentUserId = getSessionValue('loginuserid');
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_PROFILEACCESS_ENABLED_FORMS",
            "userid": currentUserId,
            "isOtherApiReq" : true,
            "tagList" : tabList,
        };
        
        let tablists = await requestApi.processServerRequest(params, "web");
        return tablists;
    }*/
    
    return (
        <Fragment>
            <Tabs 
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding" 
                transform={false} 
                showInkBar={true} 
                items={getTabs()}
            />
        </Fragment>
    )


}

export default Notifications;
